import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'box-icon',
    templateUrl: './box-icon.component.html',
    styleUrls: ['./box-icon.component.scss'],
    standalone: false
})
export class BoxIconComponent implements OnInit {
  @Input() src: string = '';
  constructor() {}

  ngOnInit() {}
}
